export enum ReligionEnum {
  NoResponse = 0,
  Atheist = 1,
  Baptist = 2,
  Catholic = 3,
  JehovahWitness = 4,
  Hinduism = 5,
  Islamic = 6,
  Jewish = 7,
  Orthodox = 8,
  Other = 99
}

export const ReligionOptions = [
{ id: 0, label: 'No Response' },
{ id: 1, label: 'Atheist' },
{ id: 2, label: 'Baptist' },
{ id: 3, label: 'Catholic' },
{ id: 4, label: 'Jehovah Witness' },
{ id: 5, label: 'Hinduism' },
{ id: 6, label: 'Islamic' },
{ id: 7, label: 'Jewish' },
{ id: 8, label: 'Orthodox' },
{ id: 99, label: 'Other' }
];
